module.exports = __webpack_public_path__ + "static/media/26.299a2c07.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shirts/26.png
// module id = 986
// module chunks = 0